import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';

import { merge, of } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { RoutingService } from '../../core/services/routing.service';

import { BaseComponent } from '../../shared/components/inherited/base/base.component';

@Component({
  selector: 'app-public-area',
  templateUrl: './public-area.component.html',
  styleUrls: ['./public-area.component.scss'],
})
export class PublicAreaComponent extends BaseComponent implements OnInit {
  componentIsLoading = false;
  firstLoading = true;

  fullWidthNav = false;

  constructor(private router: Router, private routingService: RoutingService) {
    super();
  }

  ngOnInit() {
    merge(of(this.routingService.getLastRouteNodeData()), this.routingService.lastRouteRouterEvents)
      .pipe(takeUntil(this.alive$))
      .subscribe((nodeData) => {
        this.handleRouteData(nodeData);
      });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      setTimeout(() => {
        this.componentIsLoading = false;
      }, 500);
    });
  }

  onDeactivate() {
    this.componentIsLoading = true;
  }

  onActivate() {
    setTimeout(() => {
      this.firstLoading = false;
    }, 1500);
  }

  handleRouteData(data: Data) {
    this.fullWidthNav = !!data.fullWidthNav;
  }
}
